import { State } from '../../reducers/rootReducer'

const globalEquipmentSearchModeSelector = (state: State): 'page' | 'global' => {
    const globalSearch = state.globalEquipmentSearch as { searchMode: 'page' | 'global' } | undefined
    return globalSearch?.searchMode || 'page'
}

export default globalEquipmentSearchModeSelector
